function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-19c4bf42\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../vue-loader/lib/selector?type=styles&index=0!./transfer.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./transfer.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-19c4bf42\",\"hasScoped\":true}!../../../../vue-loader/lib/selector?type=template&index=0!./transfer.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19c4bf42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/iexplore/components/transfer/src/transfer.vue
// module id = 1088
// module chunks = 2